import Alpine from "alpinejs";
import Zoomable from "@benbjurstrom/alpinejs-zoomable";
import lazySizes from "lazysizes";
import lightGallery from "lightgallery";
window.lightGallery = lightGallery;
import lgVideo from "lightgallery/plugins/video";
window.lgVideo = lgVideo;
import flatpickr from "flatpickr";
import "./global.js";
import "./components/mobileNativeSharing.js";
import "./components/blog-listing-carousel.js";
import "./components/blog.js";
import "./components/form.js";
import "./components/form-teambuilding.js";
import "./components/form-newcomer.js";
import blogListFilter from "./components/blog-listing.js";
import darkMode from "./components/darkMode.js";

window.Alpine = Alpine;
Alpine.plugin(Zoomable);

// IMPORTANT: Écouter l'événement AVANT de démarrer Alpine
document.addEventListener("alpine:init", () => {
  console.log("AlpineJS ready!");
  console.log("AlpineJS 2 ready!");
  Alpine.data("blogListFilter", blogListFilter);
  Alpine.data("darkMode", darkMode);
});

// Démarrer Alpine APRÈS avoir configuré les listeners
Alpine.start();

console.log("AlpineJS started!");
